import React, { createContext, useContext, useState, useEffect } from 'react';
import { apiClient } from '../config/api';

const DataContext = createContext();

export const useData = () => {
  return useContext(DataContext);
};

export const DataProvider = ({ children }) => {
  const [services, setServices] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchServices = async (force = false) => {
    if (services && !force) return services;
    try {
      setLoading(true);
      const res = await apiClient.get('/api/service-pages');
      if (res.data.success) {
        setServices(res.data.services);
        // Also save to sessionStorage for instant load on refresh
        sessionStorage.setItem('cached_services', JSON.stringify(res.data.services));
      }
    } catch (err) {
      setError('Failed to load services');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Try to load from cache first for INSTANT UI
    const cached = sessionStorage.getItem('cached_services');
    if (cached) {
      setServices(JSON.parse(cached));
      setLoading(false);
      // Fetch in background to update cache silently
      fetchServices(true);
    } else {
      fetchServices();
    }
  }, []);

  const value = {
    services,
    loading,
    error,
    refreshServices: () => fetchServices(true)
  };

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
};
